<template>
  <div :class="screenIndex===2?'slide-arrow cur':'slide-arrow'" @click="nextSection">
    <span></span>
    <span></span>
  </div>
</template>

<script>
  export default {
    props:{
      screenIndex:{
        required:true
      }
    },
    methods:{
      nextSection(){
        this.$emit('next')
      }
    }
  }
</script>